/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IKarenData, IKarenGameData, IKarenInitData, IReplayNextPlayerInteraction, IStickyFS} from "./IKarenData";
import {KarenDataParser} from "./KarenDataParser";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Karen} from "../../Karen";

export abstract class KarenParsedData {

    public readonly mode: string;
    public readonly nextMode: string;
    public readonly reels: string[][];
    public readonly evaluatedArea: string[][];
    public readonly nextReelSetName: string;
    public readonly totalWin: number;
    public readonly currentMultiplier: number;
    public readonly overlayWilds: boolean[][] | undefined;
    public readonly scatterPositions: number[] | undefined = [];
    public readonly freespinsLeft: number;
    public readonly freespinTriggeredThisSpin: boolean;
    public readonly addedNumberOfFreespinsThisSpin: number;
    public readonly numberOfFreespinsPlayed: number;
    public readonly replayNextPlayerInteraction: IReplayNextPlayerInteraction | undefined;
    public readonly showTotalWin: boolean;
    public readonly initialAreaSize: number[];
    public readonly reelsEnteringFreespin: string[][];
    public readonly scatterPositionsEnteringFreespin: number[] | undefined;
    public readonly stickyXWaysFSPositions: IStickyFS;
    public readonly stickyFSPositions: number[];
    public readonly fsXWaysSize: number;
    public readonly symbolSizes: number[][];
    public readonly initReels: string[][];
    public readonly xWInfPositions: number[][];
    public readonly wasFeatureBuy: boolean;
    // To add Avalanche Data
    // public readonly allWinPositions:boolean[][];
    // public readonly reelsAfterCollapse:string[][];


    constructor(rawData: IKarenData, parser: KarenDataParser) {
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        if (!Karen.initReels) {
            Karen.initReels = rawData.reels;
        }
        if (rawData as IKarenInitData) {
            this.initReels = rawData.reels;
            this.reels = parser.parseInitReels(rawData as IKarenInitData);
        } else {
            this.reels = parser.parseReels(rawData);
        }
        this.wasFeatureBuy = rawData.wasFeatureBuy;
        this.evaluatedArea = parser.parseEvaluatedArea(rawData);
        this.nextReelSetName = rawData.nextMode + "_REELSET";
        this.totalWin = rawData.accumulatedRoundWin != null ? parseFloat(rawData.accumulatedRoundWin) : 0;
        this.currentMultiplier = rawData.currentMultiplier != null ? rawData.currentMultiplier : 1;
        this.initialAreaSize = rawData.initialAreaSize;
        this.overlayWilds = rawData.overlayWilds;
        this.scatterPositions = this.parseScatterPositions(rawData);
        this.reelsEnteringFreespin = rawData.reelsEnteringFreespin;
        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.freespinTriggeredThisSpin = rawData.freespinTriggeredThisSpin === true;
        this.addedNumberOfFreespinsThisSpin = rawData.addedNumberOfFreespinsThisSpin != null ? rawData.addedNumberOfFreespinsThisSpin : 0;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.replayNextPlayerInteraction = SlotGame.apiPlugin.isReplay ? rawData.nextPlayerInteraction : undefined;
        this.showTotalWin = this.parseShowTotalWin();
        this.scatterPositionsEnteringFreespin = parser.parseScatterPositionsEnteringFS(rawData);
        this.stickyXWaysFSPositions = rawData.stickyXWaysFSPositions;
        this.fsXWaysSize = rawData.fsXWaysSize;
        this.symbolSizes = rawData.symbolSizes;
        if (rawData as IKarenInitData && rawData.reelsEnteringFreespin) {
            this.xWInfPositions = parser.parseXWInfPositionsOnInit(rawData);
        }
        if (rawData.mode === GameMode.FREESPIN) {
            this.stickyFSPositions = parser.parseStickyPositions(rawData);
        }

        // To add Avalanche Data
        // this.allWinPositions = rawData.allWinPositions.concat();
        // this.reelsAfterCollapse = rawData.reelsAfterCollapse.concat(); // TODO: if stacked symbol.
    }


    protected parseShowTotalWin(): boolean {
        return this.isRespinMode(this.mode) || this.isRespinMode(this.nextMode) ||
            this.isFreespinMode(this.mode) || this.isFreespinMode(this.nextMode)

    }

    protected abstract parseScatterPositions(rawData: IKarenData): number[] | undefined;

    private isRespinMode(mode: string): boolean {
        return mode === GameMode.RESPIN;  // || mode === GameMode.NORMAL_AVALANCHE || mode === GameMode.FREESPIN_AVALANCHE
    }

    private isFreespinMode(mode: string): boolean {
        return this.freespinTriggeredThisSpin || mode === GameMode.FREESPIN; // || mode === TombstoneGameMode.SUPER_FREESPIN || pick
    }
}